
import { computed, defineComponent, onMounted, onUnmounted, ref } from "vue";
import printJS from "print-js";

export default defineComponent({
  name: "PDFGenerator",
  components: {},
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const printElement = ref<HTMLElement>();
    const printWrapper = ref<HTMLElement>();
    const printContainer = ref<HTMLElement>();
    const printArea = ref<HTMLElement>();
    const showPreview = ref(false);
    let sizeUpdateInterval: any;

    const zoom = ref(1);
    const zoomMultiplier = ref(0.825);
    const totalZoom = computed(() => zoom.value * zoomMultiplier.value);
    const width = computed(() =>
      calcSize(printElement.value?.clientWidth || 0)
    );
    const height = computed(() =>
      calcSize(printElement.value?.clientHeight || 0)
    );

    onMounted(() => {
      sizeUpdateInterval = setInterval(() => updateSize(), 500);
    });
    onUnmounted(() => {
      if (sizeUpdateInterval) clearInterval(sizeUpdateInterval);
    });

    function calcSize(elementSize: number): string {
      return totalZoom.value < 1
        ? `${elementSize * totalZoom.value}px`
        : "fit-content";
    }

    function updateSize() {
      const elementWidth = printElement.value?.clientWidth;
      const containerWidth = printContainer.value?.clientWidth;

      if (!elementWidth || !containerWidth || containerWidth > elementWidth) {
        zoom.value = 1;
      } else if (zoom.value !== containerWidth / elementWidth) {
        zoom.value = containerWidth / elementWidth;
      }
    }

    async function generate() {
      showPreview.value = true;
      if (!printElement.value) return;

      printJS({
        printable: "print-element",
        type: "html",
        scanStyles: true,
        style:
          "@page { size: A4; margin-bottom: 1.5cm; } body, html { margin:0px;padding:0px; }",
        targetStyles: ["*", "font-size"],
        targetStyle: [
          "padding-left",
          "padding-right",
          "padding-bottom",
          "padding-top",
        ],
        maxWidth: 1123,
        font_size: "undefined",
      });
    }
    return {
      totalZoom,
      zoomMultiplier,
      width,
      height,
      generate,
      printElement,
      printContainer,
      printArea,
      showPreview,
      printWrapper,
    };
  },
});
